var constants = require('../constants');

var commonActions = (function() {

    var _setGenericError = function(errorMsgForUser, errorMsg) {
        // console.log(errorMsg);
        return {
            type: constants.SET_GENERIC_ERROR,
            errorMsgForUser: errorMsgForUser || 'Oops! Something went wrong! Help us improve your experience by sending an error report via our contact page.'
        };
    }

    var _clearGenericError = function() {
        return {
            type: constants.CLEAR_GENERIC_ERROR
        };
    }

    var _setGenericResponseError = function(errorMsgForUser, errorResponse){
        return {
            type: constants.SET_GENERIC_RESPONSE_ERROR,
            errorMsgForUser: errorMsgForUser || errorResponse.data.message
        };
    }

    var _clearGenericResponseError = function(){
        return {
            type: constants.CLEAR_GENERIC_RESPONSE_ERROR
        };
    }

    return {
        setGenericError: _setGenericError,
        clearGenericError: _clearGenericError,
        setGenericResponseError: _setGenericResponseError,
        clearGenericResponseError: _clearGenericResponseError
    }
})();

module.exports = commonActions;



// WEBPACK FOOTER //
// ./src/common/modules/common/actions/common.js